/* eslint-disable jsx-a11y/img-redundant-alt */ /* eslint-disable no-undef */ /* eslint-disable react/no-unescaped-entities */ /* eslint-disable no-unused-vars */

import React, {
  useState,
  useEffect,
} from "react";

import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";

import AuthUser from "../../../components/AuthUser";
import Spinner from "../../../components/Spinner";
import { useTranslation } from "react-i18next";

const Tutorial = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const { http, getToken, logout } = AuthUser();

  useEffect(() => {
    if (getToken() === undefined) {
      logout();
      navigate("/");
      return;
    }

    const fetchData = async () => {
      try {
        await getTutorial();
      } catch (error) {
        console.error("Erro ao obter tutoriais:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTutorial = async () => {
    setLoading(true);
    try {
      const res = await http.get("/tutorial");
      setTickets(res?.data?.videos || []);
    } catch (e) {
      console.error("Erro ao carregar tutoriais:", e);
      setTickets([]);
    } finally {
      setLoading(false);
    }
  };

  const openVideo = (videoUrl) => {
    if (!videoUrl) return;
    // abre em nova aba
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  const columns = [
    {
      title: t("Ordem"),
      dataIndex: "ordem", // <-- ajusta se teu backend usar outro nome (ex: order, ordem_num, etc.)
      key: "ordem",
      width: 120,
      sorter: (a, b) => Number(a?.ordem || 0) - Number(b?.ordem || 0),
      render: (value) => <span>{value ?? "-"}</span>,
    },
    {
      title: t("Título"),
      dataIndex: "titulo",
      key: "titulo",
      sorter: (a, b) =>
        String(a?.titulo || "").localeCompare(String(b?.titulo || ""), "pt", {
          sensitivity: "base",
        }),
      render: (text, record) => (
        <span
          onClick={() => openVideo(record?.video)}
          style={{ cursor: "pointer", textDecoration: "underline" }}
          title={record?.titulo}
        >
          {record?.titulo}
        </span>
      ),
    },
    {
      title: t("Vídeo"),
      dataIndex: "video",
      key: "video",
      width: 90,
      render: (text, record) =>
        record?.video ? (
          <a
            title={t("Abrir vídeo")}
            className="dropdown-item"
            href={record.video}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa fa-video" />
          </a>
        ) : (
          <span>-</span>
        ),
    },
  ];

  if (loading) return <Spinner />;

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs maintitle={t("Tutorial")} title="Dashboard" />

        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <Table
                className="table-striped"
                rowKey={(record) => record.id}
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={tickets?.length > 0 ? tickets : []}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
